import React, {Fragment, memo} from 'react';
import {useSelector} from 'react-redux';

import {translate} from '@mapsight/ui/src/js/helpers/i18n';

import {detailsFeatureSelector} from '../../mapsight-glue/store/selectors';
import {useNavPos} from '../../hooks';

function DetailsContent({}) {
	const navPos = useNavPos();
	const detailsFeature = useSelector(detailsFeatureSelector);

	const html = navPos.home ?
		navPos.app.description :
		detailsFeature?.properties?.description;

	const moreHref = detailsFeature?.properties?.moreInfoHref;

	return (html && <Fragment>
		<div className="stade-text stade-details-content">
			<div className="stade-details-content__html" dangerouslySetInnerHTML={{__html: html}} />
		</div>
		{moreHref &&
			<div className="stade-widget stade-widget--with-bg stade-widget__more">
				<h2>{translate('stade.text.more.caption')}</h2>
				<p>{`${translate('stade.text.more.text')} `}
					<a href={moreHref}>{translate('stade.text.more.link')}</a>
				</p>
			</div>
		}
	</Fragment>);
}

export default memo(DetailsContent);
